<template>
  <section id="projects" class="section">
    <div class="container">
      Projects
    </div>
  </section>
</template>

<script>
export default {
  name: 'Projects',
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
